<template>
  <el-dropdown trigger="click" @command="handleChgRole">
    <div>
      <i class="fa ly-icon-role fa-lg"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item of ops"
        :key="item.rid"
        :disabled="lastRole === item.rid"
        :command="item.rid"
        >{{ item.name }}</el-dropdown-item
      >
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import { chgRole } from "@/api/login";
export default {
  data() {
    return {
      ops: this.$store.getters.userRoles,
    };
  },
  computed: {
    lastRole() {
      return this.$store.getters.userInfo.lastRole;
    },
  },
  methods: {
    handleChgRole(rid) {
      var loginForm = {
        username: this.$store.getters.userInfo.loginName,
        cid: this.$store.getters.userInfo.cid,
        rid: rid,
      };
      chgRole(loginForm)
        .then((res) => {
          // 切换角色
          this.$store.dispatch("switchRole", res.token);
          // In order to make the cached page re-rendered
          this.$store.dispatch("tagsView/delAllCachedViews", this.$route);
          // 關聯其他所有的視圖
          this.$store.dispatch("tagsView/delAllViews");
          // 刷新本地页面，重新取得用户，路由及角色信息
          // this.$router.push({ path: "/" });
          window.location.href = "/index.htm";
        })
        .catch((err) => {
          this.lyMsgError(err);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UserRoles/index.vue